angular
    .module("index.service")
    .service("commonService", ['$q', '$filter', '$rootScope', '$timeout', 'httpService', 'popupService',
        function ($q, $filter, $rootScope, $timeout, httpService, popupService) {
            return {
                saveRecentPolicyAndClaim: saveRecentPolicyAndClaim,
                openLink: openLink,
                redirectLink: redirectLink,
                veryfiToken: veryfiToken,
                detectIE: detectIE,
                showValidationError: showValidationError,
                formatDate: formatDate,
                getRecentActivity: getRecentActivity,
                getNotificationMessage: getNotificationMessage,
                getLastEtlTime: getLastEtlTime,
                generateRandomId: generateRandomId
            };

            function saveRecentPolicyAndClaim(type, policy, claim) {
                sessionStorage.RecentlySelectedType = $filter('enstr64')(type);

                if (!!policy && policy.EmployerId) {
                    sessionStorage.Policy = $filter('enstr64')(JSON.stringify(policy));
                }

                if (!!claim && claim.ClaimId) {
                    sessionStorage.Claim = $filter('enstr64')(JSON.stringify(claim));
                }

            }

            function getLastEtlTime() {
                var apiTarget = "api/common/getlastetltime",
                    values = '';
                httpService.httpRequest(apiTarget, values).then(function (data) { // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        var response = angular.fromJson(data);
                        $rootScope.etlTime = response === $filter('undefined')(response) ? "" : response;
                        sessionStorage.EtlTime = $rootScope.etlTime;
                    } //if data==false
                });
            }

            function openLink(link) {
                window.open(link, '_blank');
            }

            function redirectLink(link) {
                window.location.href = link;
            }

            function veryfiToken(token, isActivationToken) {
                var def = $q.defer(),
                    APITarget = "api/credentials/verifytoken",
                    Values = {
                        Token: token,
                        IsActivationToken: isActivationToken
                    };

                httpService.httpRequest(APITarget, JSON.stringify(Values), 'POST').then(function (result) {
                    def.resolve(angular.fromJson(result));
                });

                return def.promise;
            }

            function detectIE() {
                var ua = window.navigator.userAgent;

                var msie = ua.indexOf('MSIE ');
                if (msie > 0) {
                    // IE 10 or older => return version number
                    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                }

                var trident = ua.indexOf('Trident/');
                if (trident > 0) {
                    // IE 11 => return version number
                    var rv = ua.indexOf('rv:');
                    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                }

                var edge = ua.indexOf('Edge/');
                if (edge > 0) {
                    // IE 12 => return version number
                    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                }

                // other browser
                return false;
            }

            function showValidationError($scope, data, title, okCallback) {
                var errorResult = angular.fromJson(data);
                if (angular.isDefined(errorResult) && angular.isDefined(errorResult.Errors)) {
                    $scope.serverErrors = errorResult.Errors;
                }
                popupService.showValidationServerErrors(errorResult, title, okCallback);
            }

            function formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                if (month < 10) month = '0' + month;
                if (day < 10) day = '0' + day;
                return year.toString() + month.toString() + day.toString();
            }

            function getRecentActivity() {

                var def = $q.defer();
                var APITarget = 'api/activity/getactivity';
                values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    DateOfBirth: $rootScope.user.DateOfBirth,
                    BusinessUnit: $rootScope.getSelectedJurisdiction()
                });

                $timeout(function () {
                    httpService.httpRequest(APITarget, values).then(function (data) {
                        if (data != false) {
                            if (data == "logout") {
                                $rootScope.userLogout();
                                defer.resolve(0);
                            } else {
                                var response = angular.fromJson(data);
                                def.resolve(response);
                            }
                        } else {
                            def.reject();
                        }
                    });
                }, 1000);

                return def.promise;
            }

            function getNotificationMessage() {
                var APITarget = 'api/notification/get',
                    values = '';

                httpService.httpRequest(APITarget, values).then(function (data) {
                    var notification = angular.fromJson(data);
                    if (angular.isArray(notification)) {
                        $rootScope.notification = notification.filter(function (item) {
                            return item.Enabled === true;
                        });
                    }
                });
            }

            function generateRandomId() {
                // then to call it, plus stitch in '4' in the third group
                var guid = (S4() + S4() + "_" + S4() + "_4" + S4().substr(0, 3) + "_" + S4() + "_" + S4() + S4() + S4()).toLowerCase();
                return guid;
            }

            function S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            }
        }
    ]);